import {
   GET_PURCHASE_CHALLANS,
   GET_PURCHASE_CHALLAN,
   UPDATE_PURCHASE_CHALLAN,
   ADD_PURCHASE_CHALLAN,
   DELETE_PURCHASE_CHALLAN,
   GET_LAST_PURCHASE_CHALLAN_DAYBOOK,
   EMPTY_ONE_PURCHASE_CHALLAN_INVOICE,
   GET_PURCHASE_ORDER_DOCUMENT,
   GET_PURCHASE_CHALLAN_DOCUMENT,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_PURCHASE_CHALLANS:
         return { ...state, list: payload.data, totalCount: totalCount, isLoading: false, pagination: action.payload.pagination };

      case GET_PURCHASE_CHALLAN:
         return { ...state, single: payload || initialState.single, isLoading: false, };

      case UPDATE_PURCHASE_CHALLAN:
         return { ...state, list: state.list.map((item) => (item.id === payload.id ? payload : item)), isLoading: false, };

      case ADD_PURCHASE_CHALLAN:
         return { ...state, list: [payload, ...state.list], totalCount: state.totalCount + 1, isLoading: false, };

      case DELETE_PURCHASE_CHALLAN:
         return { ...state, list: state.list.filter((item) => item.id !== payload.id), totalCount: state.totalCount - 1, isLoading: false, };

      case GET_LAST_PURCHASE_CHALLAN_DAYBOOK:
         return { ...state, lastPurchaseDaybook: payload, };

      case GET_PURCHASE_ORDER_DOCUMENT:
         return { ...state, orderDocument: payload.data, };

      case GET_PURCHASE_CHALLAN_DOCUMENT:
         return { ...state, challanDocument: payload.data, };

      case EMPTY_ONE_PURCHASE_CHALLAN_INVOICE:
         return { ...state, ingle: payload, };

      default:
         return state;
   }
};

export default reducer;
